import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type OrganisationBrand from "./OrganisationBrand";
import type OrganisationReportSpec from "./OrganisationReportSpec";
import type User from "./User";

@Model()
class OrganisationReportSpecGroup extends ApplicationRecord {
  static jsonapiType = "organisation_report_spec_groups";

  @Attr() distributionListId: number;

  @Attr() onFriday: boolean;

  @Attr() onMonday: boolean;

  @Attr() onSaturday: boolean;

  @Attr() onSunday: boolean;

  @Attr() onThursday: boolean;

  @Attr() onTuesday: boolean;

  @Attr() onWednesday: boolean;

  @BelongsTo() organisation: Organisation;

  @BelongsTo() organisationBrand: OrganisationBrand;

  @Attr() organisationBrandId: number;

  @Attr() organisationId: number;

  @Attr() recipients: any[];

  @HasMany() specifications: OrganisationReportSpec[];

  @Attr() subject: string;

  @Attr() timeZone: string;

  @Attr() useDistributionList: boolean;

  @BelongsTo() userAccount: User;

  @Attr() userAccountId: number;

  @Attr() weekdayDeliverAt: number;

  @Attr() weekendDeliverAt: number;
}

export default OrganisationReportSpecGroup;
